import { AccountOption, AccountSelectionList, Button } from '@cma/common'
import { ReactNode, useState } from 'react'
import { PlatformLoginButton } from './PlatformLoginButton'
import { UseDifferentEmailButton } from './UseDifferentEmailButton'
import { requiresPlatformLogin } from './utils'

interface SelectAccountCardProps {
  accounts: AccountOption[]
  email: string
  heading?: string
  description?: ReactNode
  onContinue(account: AccountOption): void
  onUseDifferentEmail(): void
}

export function SelectAccountCard({
  accounts,
  email,
  heading = 'Select an account',
  description,
  onContinue,
  onUseDifferentEmail
}: SelectAccountCardProps) {
  const [selectedAccount, setSelectedAccount] = useState<AccountOption>()

  return (
    <>
      <div className="space-y-6 rounded-lg bg-white px-8 py-6 shadow">
        <div className="space-y-2 text-center">
          <h1 className="text-2xl font-medium">{heading}</h1>
          <p className="text-sm text-gray-600">
            {description ?? (
              <>
                We found more than one Cloud CMA account associated with{' '}
                <span className="font-semibold">{email}</span>. Select the
                account you want to sign in with.
              </>
            )}
          </p>
        </div>
        <AccountSelectionList
          accounts={accounts}
          value={selectedAccount?.accountId}
          onChange={setSelectedAccount}
        />
        {selectedAccount && requiresPlatformLogin(selectedAccount) ? (
          <PlatformLoginButton />
        ) : (
          <Button
            type="button"
            fullWidth
            disabled={!selectedAccount}
            onClick={() => selectedAccount && onContinue(selectedAccount)}>
            Continue
          </Button>
        )}
      </div>
      <UseDifferentEmailButton onClick={onUseDifferentEmail} />
    </>
  )
}
